import React from 'react';
import { faCheck, faMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { featureRows, IMembershipPackage } from '../assets/membership-options';

const MembershipPackage = ({ membership }: { membership: IMembershipPackage }) => {
    return (
        <div className="white-card">
            <h4>{membership.title}</h4>
            <hr className="primary-hr" />
            <div className="py-4">
                <span className="text-3xl font-light">€{membership.price}</span>
                <span className="text-sm text-gray-400"> / maand</span>
            </div>
            <ul className="space-y-3">
                {featureRows.map(({ key, label }) => {
                    const val = membership.features[key];
                    const active = typeof val === 'boolean' ? val : true;
                    return (
                        <li key={key} className="flex items-center gap-3 text-sm">
                            <FontAwesomeIcon
                                icon={active ? faCheck : faMinus}
                                className={active ? 'text-primary-500 shrink-0' : 'text-gray-300 shrink-0'}
                            />
                            <span className={active ? 'text-gray-700' : 'text-gray-400'}>
                                {label}{typeof val === 'string' ? `: ${val}` : ''}
                            </span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default MembershipPackage;
